import React from 'react';
import { FileText } from 'lucide-react';
import type { Attachment } from '../../types';

interface AttachmentPreviewProps {
  attachment: Attachment;
}

const AttachmentPreview = React.memo(function AttachmentPreview({
  attachment,
}: AttachmentPreviewProps) {
  return (
    <div className="rw-attachment-preview">
      {attachment.previewUrl ? (
        <img src={attachment.previewUrl} alt={attachment.name} loading="lazy" decoding="async" />
      ) : (
        <FileText className="w-4 h-4" aria-hidden="true" />
      )}
      <bdi className="rw-attachment-name" title={attachment.name}>
        {attachment.name}
      </bdi>
    </div>
  );
});

export default AttachmentPreview;
